import { react2angular } from '@Shared.Angular/flowingly.helper/react2angular';
import ProcedureActionImage from './ProcedureActionImage';

const ProcedureActionImageBridge = react2angular(ProcedureActionImage, [
  'imageDataUrl',
  'overlays',
  'onImageClick',
  'enableWheelZoom',
  'hideZoomSlider'
]);

export default ProcedureActionImageBridge;
